import * as React from "react";
const SvgFiRrSnake = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-snake_svg__a)">
      <path d="M18.5 6.49a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
      <path d="M20.5 17h-.223c-1.135-.71-2.566-2.053-4.157-3.904-2.009-2.336-2.115-3.57-2.12-4.46a5.4 5.4 0 0 1 1.011-.103c1.949 1.92 5.1 1.918 7.024-.007l.875-.884a3.79 3.79 0 0 0 .001-5.301l-.876-.886c-1.926-1.925-5.088-1.897-7.037.025-1.438.058-4.111.393-5.862 1.977-.975.882-2.137 2.47-2.137 5.033 0 .782.118 1.6.326 2.425-.57-.27-1.389-.56-2.59-.851a2.215 2.215 0 0 0-2.719 2.425c.356 2.819.952 3.535 1.161 3.786l.63.726h-.308c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h17c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5zM10.479 4.94c1.332-1.205 3.661-1.424 4.6-1.462.492-.02.953-.23 1.335-.605 1.17-1.153 3.057-1.156 4.208-.004l.866.876a1.784 1.784 0 0 1 0 2.493l-.865.874c-1.151 1.15-3.038 1.147-4.206-.003-.445-.438-1.012-.654-1.583-.61-1.768.14-2.19.528-2.346.67-.327.299-.486.73-.486 1.32 0 1.079 0 2.882 2.604 5.912a33 33 0 0 0 2.463 2.597l-4.142-.005c-1.976-2.08-3.926-5.705-3.926-8.503 0-1.828.804-2.94 1.479-3.55zm-6.407 7.116a.21.21 0 0 1 .192-.05c2.314.563 2.728 1.034 2.783 1.098l2.296 2.448c.313.51.644.995.984 1.449h-3.87L4.703 14.98c-.042-.052-.425-.564-.7-2.741a.2.2 0 0 1 .069-.183M20.501 22H3.5c-.827 0-1.5-.673-1.5-1.5S2.673 19 3.5 19h17a1.501 1.501 0 0 1 .001 3" />
    </g>
    <defs>
      <clipPath id="fi-rr-snake_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSnake;
